// ! This file was auto-generated by @rtk-query/codegen-openapi. Do not override this file.

import { api } from "~/redux/api/everest/codegenApi";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getClientsByExtIdOauthTokensAndIntegration: build.query<GetClientsByExtIdOauthTokensAndIntegrationApiResponse, GetClientsByExtIdOauthTokensAndIntegrationApiArg>({
            query: (queryArg) => ({
                url: `/clients/${queryArg.extId}/oauth-tokens/${queryArg.integration}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateDocument: build.mutation<UpdateDocumentApiResponse, UpdateDocumentApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}`,
                method: "PUT",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createVersion: build.mutation<CreateVersionApiResponse, CreateVersionApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/`,
                method: "POST",
                body: queryArg.body,
                params: { text: queryArg.text },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getAllVersions: build.query<GetAllVersionsApiResponse, GetAllVersionsApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getVersion: build.query<GetVersionApiResponse, GetVersionApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteVersion: build.mutation<DeleteVersionApiResponse, DeleteVersionApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createVersionBackup: build.mutation<CreateVersionBackupApiResponse, CreateVersionBackupApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/backups`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        downloadVersion: build.query<DownloadVersionApiResponse, DownloadVersionApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/download/${queryArg.fileType}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        addWorkflow: build.mutation<AddWorkflowApiResponse, AddWorkflowApiArg>({
            query: () => ({ url: `/workflows/`, method: "POST" }),
        }),
        getAllWorkflows: build.query<GetAllWorkflowsApiResponse, GetAllWorkflowsApiArg>({
            query: (queryArg) => ({
                url: `/workflows/`,
                params: {
                    completed: queryArg.completed,
                    published: queryArg.published,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWorkflow: build.query<GetWorkflowApiResponse, GetWorkflowApiArg>({
            query: (queryArg) => ({ url: `/workflows/${queryArg.workflowId}`, rtkQueryOptions: (queryArg as any)?.rtkQueryOptions }),
        }),
        patchWorkflowsByWorkflowId: build.mutation<PatchWorkflowsByWorkflowIdApiResponse, PatchWorkflowsByWorkflowIdApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteWorkflow: build.mutation<DeleteWorkflowApiResponse, DeleteWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createTicketPackage: build.mutation<CreateTicketPackageApiResponse, CreateTicketPackageApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/packages/`,
                method: "POST",
                body: queryArg.createTicketPackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketPackageRecipients: build.query<GetTicketPackageRecipientsApiResponse, GetTicketPackageRecipientsApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/packages/recipients`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketPackageActivities: build.query<GetTicketPackageActivitiesApiResponse, GetTicketPackageActivitiesApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/packages/activities`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        signTicketPackage: build.mutation<SignTicketPackageApiResponse, SignTicketPackageApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/packages/sign`,
                method: "POST",
                body: queryArg.signTicketPackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        viewTicketPackage: build.mutation<ViewTicketPackageApiResponse, ViewTicketPackageApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/packages/view`,
                method: "POST",
                body: queryArg.viewTicketPackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        remindTicketPackageRecipient: build.mutation<RemindTicketPackageRecipientApiResponse, RemindTicketPackageRecipientApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/packages/remind`,
                method: "POST",
                body: queryArg.remindSignerRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getInitialSigners: build.query<GetInitialSignersApiResponse, GetInitialSignersApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/packages/initial-signers`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        reassignInitialSigner: build.mutation<ReassignInitialSignerApiResponse, ReassignInitialSignerApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/packages/reassign-initial-signer`,
                method: "PATCH",
                body: queryArg.reassignInitialSignerRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getEsignatures: build.query<GetEsignaturesApiResponse, GetEsignaturesApiArg>({
            query: () => ({ url: `/esignatures/` }),
        }),
        postEsignatures: build.mutation<PostEsignaturesApiResponse, PostEsignaturesApiArg>({
            query: (queryArg) => ({
                url: `/esignatures/`,
                method: "POST",
                body: queryArg.eSignatureRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteEsignaturesByEsignatureId: build.mutation<DeleteEsignaturesByEsignatureIdApiResponse, DeleteEsignaturesByEsignatureIdApiArg>({
            query: (queryArg) => ({
                url: `/esignatures/${queryArg.esignatureId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getEsignaturesByEsignatureId: build.query<GetEsignaturesByEsignatureIdApiResponse, GetEsignaturesByEsignatureIdApiArg>({
            query: (queryArg) => ({ url: `/esignatures/${queryArg.esignatureId}`, rtkQueryOptions: (queryArg as any)?.rtkQueryOptions }),
        }),
        patchEsignaturesByEsignatureId: build.mutation<PatchEsignaturesByEsignatureIdApiResponse, PatchEsignaturesByEsignatureIdApiArg>({
            query: (queryArg) => ({
                url: `/esignatures/${queryArg.esignatureId}`,
                method: "PATCH",
                body: queryArg.eSignatureRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getEsignaturesCheck: build.query<GetEsignaturesCheckApiResponse, GetEsignaturesCheckApiArg>({
            query: () => ({ url: `/esignatures/check` }),
        }),
        addIntakeForm: build.mutation<AddIntakeFormApiResponse, AddIntakeFormApiArg>({
            query: (queryArg) => ({
                url: `/intake-forms/`,
                method: "POST",
                body: queryArg.intakeFormReq,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        addTicket: build.mutation<AddTicketApiResponse, AddTicketApiArg>({
            query: (queryArg) => ({
                url: `/tickets/`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicket: build.query<GetTicketApiResponse, GetTicketApiArg>({
            query: (queryArg) => ({ url: `/tickets/${queryArg.ticketId}/`, rtkQueryOptions: (queryArg as any)?.rtkQueryOptions }),
        }),
        updateTicket: build.mutation<UpdateTicketApiResponse, UpdateTicketApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/`,
                method: "PUT",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteTicket: build.mutation<DeleteTicketApiResponse, DeleteTicketApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchTicketsByTicketId: build.mutation<PatchTicketsByTicketIdApiResponse, PatchTicketsByTicketIdApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        ticketComplete: build.mutation<TicketCompleteApiResponse, TicketCompleteApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/complete/`,
                method: "PUT",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        uploadSigned: build.mutation<UploadSignedApiResponse, UploadSignedApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/upload-signed/`,
                method: "POST",
                body: queryArg.body,
                params: { text: queryArg.text },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateTurnTracking: build.mutation<UpdateTurnTrackingApiResponse, UpdateTurnTrackingApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/turn-trackings/${queryArg.turnId}/`,
                method: "PATCH",
                body: queryArg.turnTrackingEditReq,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketIntakeForm: build.query<GetTicketIntakeFormApiResponse, GetTicketIntakeFormApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/intake-form/`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchTicketsByTicketIdJudgmentResultsAndJudgmentResultId: build.mutation<PatchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdApiResponse, PatchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/judgment-results/${queryArg.judgmentResultId}/`,
                method: "PATCH",
                body: queryArg.judgmentResultReq,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketsByTicketIdApprovals: build.query<GetTicketsByTicketIdApprovalsApiResponse, GetTicketsByTicketIdApprovalsApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/approvals/`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        backToReview: build.mutation<BackToReviewApiResponse, BackToReviewApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/back-to-review/`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getDocumentDetails: build.query<GetDocumentDetailsApiResponse, GetDocumentDetailsApiArg>({
            query: (queryArg) => ({ url: `/tickets/${queryArg.ticketId}/document/`, rtkQueryOptions: (queryArg as any)?.rtkQueryOptions }),
        }),
        getTicketSummary: build.query<GetTicketSummaryApiResponse, GetTicketSummaryApiArg>({
            query: (queryArg) => ({ url: `/tickets/${queryArg.ticketId}/summary/`, rtkQueryOptions: (queryArg as any)?.rtkQueryOptions }),
        }),
        getTicketCurrentStageDetails: build.query<GetTicketCurrentStageDetailsApiResponse, GetTicketCurrentStageDetailsApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/current-stage/`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPermissionsAccesibility: build.mutation<GetPermissionsAccesibilityApiResponse, GetPermissionsAccesibilityApiArg>({
            query: (queryArg) => ({
                url: `/clients/permissions/check-user-accessibility`,
                method: "POST",
                body: queryArg.permissionsBody,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createRouting: build.mutation<CreateRoutingApiResponse, CreateRoutingApiArg>({
            query: (queryArg) => ({
                url: `/routing`,
                method: "POST",
                body: queryArg.routingCreateRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        searchRouting: build.query<SearchRoutingApiResponse, SearchRoutingApiArg>({
            query: (queryArg) => ({
                url: `/routing/search`,
                params: {
                    pageSize: queryArg.pageSize,
                    currentPage: queryArg.currentPage,
                    searchString: queryArg.searchString,
                    orderBy: queryArg.orderBy,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getRoutingById: build.query<GetRoutingByIdApiResponse, GetRoutingByIdApiArg>({
            query: (queryArg) => ({ url: `/routing/${queryArg.routingId}`, rtkQueryOptions: (queryArg as any)?.rtkQueryOptions }),
        }),
        updateRouting: build.mutation<UpdateRoutingApiResponse, UpdateRoutingApiArg>({
            query: (queryArg) => ({
                url: `/routing/${queryArg.routingId}`,
                method: "PUT",
                body: queryArg.routingUpdateRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteRouting: build.mutation<DeleteRoutingApiResponse, DeleteRoutingApiArg>({
            query: (queryArg) => ({
                url: `/routing/${queryArg.routingId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getUnroutedWorkflows: build.query<GetUnroutedWorkflowsApiResponse, GetUnroutedWorkflowsApiArg>({
            query: () => ({ url: `/routing/unrouted-workflows` }),
        }),
        getRoutingConfiguration: build.query<GetRoutingConfigurationApiResponse, GetRoutingConfigurationApiArg>({
            query: () => ({ url: `/routing-configuration` }),
        }),
        patchRoutingConfiguration: build.mutation<PatchRoutingConfigurationApiResponse, PatchRoutingConfigurationApiArg>({
            query: (queryArg) => ({
                url: `/routing-configuration`,
                method: "PATCH",
                body: queryArg.routingConfigurationPatchRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getActivationStatus: build.query<GetActivationStatusApiResponse, GetActivationStatusApiArg>({
            query: () => ({ url: `/routing-configuration/activation-status` }),
        }),
        getWorkflowParties: build.query<GetWorkflowPartiesApiResponse, GetWorkflowPartiesApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}/parties`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getActivities: build.query<GetActivitiesApiResponse, GetActivitiesApiArg>({
            query: (queryArg) => ({
                url: `/activities/`,
                params: {
                    entityType: queryArg.entityType,
                    entityId: queryArg.entityId,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postActivities: build.mutation<PostActivitiesApiResponse, PostActivitiesApiArg>({
            query: (queryArg) => ({
                url: `/activities/`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getActivitiesTokenize: build.query<GetActivitiesTokenizeApiResponse, GetActivitiesTokenizeApiArg>({
            query: (queryArg) => ({
                url: `/activities/tokenize`,
                params: {
                    textList: queryArg.textList,
                    highlightsIndex: queryArg.highlightsIndex,
                    riskId: queryArg.riskId,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postActivitiesTokenize: build.mutation<PostActivitiesTokenizeApiResponse, PostActivitiesTokenizeApiArg>({
            query: (queryArg) => ({
                url: `/activities/tokenize`,
                method: "POST",
                params: {
                    textList: queryArg.textList,
                    highlightsIndex: queryArg.highlightsIndex,
                    riskId: queryArg.riskId,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getAdobesignAuthorize: build.query<GetAdobesignAuthorizeApiResponse, GetAdobesignAuthorizeApiArg>({
            query: (queryArg) => ({
                url: `/adobesign/authorize`,
                params: { state: queryArg.state },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getAdobesignWebhook: build.query<GetAdobesignWebhookApiResponse, GetAdobesignWebhookApiArg>({
            query: () => ({ url: `/adobesign/webhook` }),
        }),
        postAdobesignWebhook: build.mutation<PostAdobesignWebhookApiResponse, PostAdobesignWebhookApiArg>({
            query: (queryArg) => ({
                url: `/adobesign/webhook`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getDsAuthorize: build.query<GetDsAuthorizeApiResponse, GetDsAuthorizeApiArg>({
            query: (queryArg) => ({
                url: `/ds/authorize`,
                params: { state: queryArg.state },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postDsWebhook: build.mutation<PostDsWebhookApiResponse, PostDsWebhookApiArg>({
            query: () => ({ url: `/ds/webhook`, method: "POST" }),
        }),
        postSalesforceLogin: build.mutation<PostSalesforceLoginApiResponse, PostSalesforceLoginApiArg>({
            query: (queryArg) => ({
                url: `/salesforce/login`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getSalesforceAuthorize: build.query<GetSalesforceAuthorizeApiResponse, GetSalesforceAuthorizeApiArg>({
            query: (queryArg) => ({
                url: `/salesforce/authorize`,
                params: { state: queryArg.state },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postAttachments: build.mutation<PostAttachmentsApiResponse, PostAttachmentsApiArg>({
            query: (queryArg) => ({
                url: `/attachments/`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getAttachmentsByAttachmentId: build.query<GetAttachmentsByAttachmentIdApiResponse, GetAttachmentsByAttachmentIdApiArg>({
            query: (queryArg) => ({ url: `/attachments/${queryArg.attachmentId}/`, rtkQueryOptions: (queryArg as any)?.rtkQueryOptions }),
        }),
        postClientsPermissionsVersionsByVersionId: build.mutation<PostClientsPermissionsVersionsByVersionIdApiResponse, PostClientsPermissionsVersionsByVersionIdApiArg>({
            query: (queryArg) => ({
                url: `/clients/permissions/versions/${queryArg.versionId}`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getClientsByClientExtIdOauthTokensAndProviderProviderId: build.query<GetClientsByClientExtIdOauthTokensAndProviderProviderIdApiResponse, GetClientsByClientExtIdOauthTokensAndProviderProviderIdApiArg>({
            query: (queryArg) => ({
                url: `/clients/${queryArg.clientExtId}/oauth-tokens/${queryArg.provider}/${queryArg.providerId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getCompanies: build.query<GetCompaniesApiResponse, GetCompaniesApiArg>({
            query: (queryArg) => ({
                url: `/companies`,
                params: {
                    q: queryArg.q,
                    limit: queryArg.limit,
                    offset: queryArg.offset,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getContractTypes: build.query<GetContractTypesApiResponse, GetContractTypesApiArg>({
            query: (queryArg) => ({
                url: `/contract-types`,
                params: { limit: queryArg.limit, offset: queryArg.offset },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getCurrencies: build.query<GetCurrenciesApiResponse, GetCurrenciesApiArg>({
            query: () => ({ url: `/currencies` }),
        }),
        getCrms: build.query<GetCrmsApiResponse, GetCrmsApiArg>({
            query: () => ({ url: `/crms/` }),
        }),
        deleteCrmsByCrmId: build.mutation<DeleteCrmsByCrmIdApiResponse, DeleteCrmsByCrmIdApiArg>({
            query: (queryArg) => ({
                url: `/crms/${queryArg.crmId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postEsignaturesUser: build.mutation<PostEsignaturesUserApiResponse, PostEsignaturesUserApiArg>({
            query: (queryArg) => ({
                url: `/esignatures/user`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postEsignaturesByEsignatureIdLogin: build.mutation<PostEsignaturesByEsignatureIdLoginApiResponse, PostEsignaturesByEsignatureIdLoginApiArg>({
            query: (queryArg) => ({
                url: `/esignatures/${queryArg.esignatureId}/login`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getSuppliersBySupplierId: build.query<GetSuppliersBySupplierIdApiResponse, GetSuppliersBySupplierIdApiArg>({
            query: (queryArg) => ({
                url: `/suppliers/${queryArg.supplierId}`,
                params: { include_contacts: queryArg.includeContacts },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getIntegrateWorkflowByParentWorkflowIdIntakeFormLink: build.query<GetIntegrateWorkflowByParentWorkflowIdIntakeFormLinkApiResponse, GetIntegrateWorkflowByParentWorkflowIdIntakeFormLinkApiArg>({
            query: (queryArg) => ({
                url: `/integrate-workflow/${queryArg.parentWorkflowId}/intake-form/link/`,
                params: { reference_id: queryArg.referenceId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getIntegrateWorkflowByParentWorkflowIdSuppliers: build.query<GetIntegrateWorkflowByParentWorkflowIdSuppliersApiResponse, GetIntegrateWorkflowByParentWorkflowIdSuppliersApiArg>({
            query: (queryArg) => ({
                url: `/integrate-workflow/${queryArg.parentWorkflowId}/suppliers`,
                params: { q: queryArg.q, page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getIntegrateWorkflowAmendByContractRecordUniqueIdIntakeForm: build.query<GetIntegrateWorkflowAmendByContractRecordUniqueIdIntakeFormApiResponse, GetIntegrateWorkflowAmendByContractRecordUniqueIdIntakeFormApiArg>({
            query: (queryArg) => ({
                url: `/integrate-workflow/amend/${queryArg.contractRecordUniqueId}/intake-form`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postPermissionsCheckUserAccessibility: build.mutation<PostPermissionsCheckUserAccessibilityApiResponse, PostPermissionsCheckUserAccessibilityApiArg>({
            query: (queryArg) => ({
                url: `/permissions/check-user-accessibility`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postPermissionsVersionsByVersionId: build.mutation<PostPermissionsVersionsByVersionIdApiResponse, PostPermissionsVersionsByVersionIdApiArg>({
            query: (queryArg) => ({
                url: `/permissions/versions/${queryArg.versionId}`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postPermissionsVersionsByVersionIdCheckDocViewPermission: build.mutation<PostPermissionsVersionsByVersionIdCheckDocViewPermissionApiResponse, PostPermissionsVersionsByVersionIdCheckDocViewPermissionApiArg>({
            query: (queryArg) => ({
                url: `/permissions/versions/${queryArg.versionId}/check-doc-view-permission`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postPackagesMultiTicketValidate: build.mutation<PostPackagesMultiTicketValidateApiResponse, PostPackagesMultiTicketValidateApiArg>({
            query: (queryArg) => ({
                url: `/packages/multi-ticket/validate`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postPackagesMultiTicket: build.mutation<PostPackagesMultiTicketApiResponse, PostPackagesMultiTicketApiArg>({
            query: (queryArg) => ({
                url: `/packages/multi-ticket/`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getInternalAstroActiveSalesforceIntegrations: build.query<GetInternalAstroActiveSalesforceIntegrationsApiResponse, GetInternalAstroActiveSalesforceIntegrationsApiArg>({
            query: () => ({ url: `/internal/astro/active-salesforce-integrations` }),
        }),
        getInternalDocumentsByDocumentIdPermissions: build.query<GetInternalDocumentsByDocumentIdPermissionsApiResponse, GetInternalDocumentsByDocumentIdPermissionsApiArg>({
            query: (queryArg) => ({
                url: `/internal/documents/${queryArg.documentId}/permissions`,
                params: { userIds: queryArg.userIds },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getInternalDocumentsByDocumentIdSummary: build.query<GetInternalDocumentsByDocumentIdSummaryApiResponse, GetInternalDocumentsByDocumentIdSummaryApiArg>({
            query: (queryArg) => ({
                url: `/internal/documents/${queryArg.documentId}/summary`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getInternalDocumentsByDocumentIdVersionsAndVersionId: build.query<GetInternalDocumentsByDocumentIdVersionsAndVersionIdApiResponse, GetInternalDocumentsByDocumentIdVersionsAndVersionIdApiArg>({
            query: (queryArg) => ({
                url: `/internal/documents/${queryArg.documentId}/versions/${queryArg.versionId}`,
                headers: { EVISORT_CLIENT_ID: queryArg.evisortClientId },
                params: { location_key: queryArg.locationKey },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchInternalDocumentsByDocumentIdVersionsAndVersionIdLocationsKey: build.mutation<PatchInternalDocumentsByDocumentIdVersionsAndVersionIdLocationsKeyApiResponse, PatchInternalDocumentsByDocumentIdVersionsAndVersionIdLocationsKeyApiArg>({
            query: (queryArg) => ({
                url: `/internal/documents/${queryArg.documentId}/versions/${queryArg.versionId}/locations/${queryArg.key}`,
                method: "PATCH",
                body: queryArg.body,
                headers: {
                    EVISORT_CLIENT_ID: queryArg.evisortClientId,
                    EVISORT_USER_ID: queryArg.evisortUserId,
                    EVISORT_EDITORS_ID: queryArg.evisortEditorsId,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getInternalTicketsByTicketIdSummary: build.query<GetInternalTicketsByTicketIdSummaryApiResponse, GetInternalTicketsByTicketIdSummaryApiArg>({
            query: (queryArg) => ({
                url: `/internal/tickets/${queryArg.ticketId}/summary`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postInternalVersionsByVersionIdCheckDocViewPermission: build.mutation<PostInternalVersionsByVersionIdCheckDocViewPermissionApiResponse, PostInternalVersionsByVersionIdCheckDocViewPermissionApiArg>({
            query: (queryArg) => ({
                url: `/internal/versions/${queryArg.versionId}/check-doc-view-permission`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postDocumentsByDocumentIdVersionsCompare: build.mutation<PostDocumentsByDocumentIdVersionsCompareApiResponse, PostDocumentsByDocumentIdVersionsCompareApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/compare`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postDocumentsByDocumentIdVersionsAndVersionIdBumpVersion: build.mutation<PostDocumentsByDocumentIdVersionsAndVersionIdBumpVersionApiResponse, PostDocumentsByDocumentIdVersionsAndVersionIdBumpVersionApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/bump-version`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postDocumentsByDocumentIdVersionsAndVersionIdCommentsCommentId: build.mutation<PostDocumentsByDocumentIdVersionsAndVersionIdCommentsCommentIdApiResponse, PostDocumentsByDocumentIdVersionsAndVersionIdCommentsCommentIdApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/comments/${queryArg.commentId}`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postDocumentsByDocumentIdVersionsAndVersionIdConvertToDocx: build.mutation<PostDocumentsByDocumentIdVersionsAndVersionIdConvertToDocxApiResponse, PostDocumentsByDocumentIdVersionsAndVersionIdConvertToDocxApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/convert-to-docx`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getDocumentsByDocumentIdVersionsAndVersionIdDownloadEmailAttachment: build.query<GetDocumentsByDocumentIdVersionsAndVersionIdDownloadEmailAttachmentApiResponse, GetDocumentsByDocumentIdVersionsAndVersionIdDownloadEmailAttachmentApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/download-email-attachment`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getDocumentsByDocumentIdVersionsAndVersionIdDownloadFile: build.query<GetDocumentsByDocumentIdVersionsAndVersionIdDownloadFileApiResponse, GetDocumentsByDocumentIdVersionsAndVersionIdDownloadFileApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/download-file`,
                params: {
                    isSharepointDownload: queryArg.isSharepointDownload,
                    isWorkingDraft: queryArg.isWorkingDraft,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getDocumentsByDocumentIdVersionsAndVersionIdEditorKey: build.query<GetDocumentsByDocumentIdVersionsAndVersionIdEditorKeyApiResponse, GetDocumentsByDocumentIdVersionsAndVersionIdEditorKeyApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/editor-key`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchDocumentsByDocumentIdVersionsAndVersionIdEditorKey: build.mutation<PatchDocumentsByDocumentIdVersionsAndVersionIdEditorKeyApiResponse, PatchDocumentsByDocumentIdVersionsAndVersionIdEditorKeyApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/editor-key`,
                method: "PATCH",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getDocumentsByDocumentIdVersionsAndVersionIdRemoteLocation: build.query<GetDocumentsByDocumentIdVersionsAndVersionIdRemoteLocationApiResponse, GetDocumentsByDocumentIdVersionsAndVersionIdRemoteLocationApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/remote-location`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postDocumentsByDocumentIdVersionsAndVersionIdSfdt: build.mutation<PostDocumentsByDocumentIdVersionsAndVersionIdSfdtApiResponse, PostDocumentsByDocumentIdVersionsAndVersionIdSfdtApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/sfdt`,
                method: "POST",
                body: queryArg.body,
                params: { isDoneEditing: queryArg.isDoneEditing },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postDocumentsByDocumentIdVersionsAndVersionIdShare: build.mutation<PostDocumentsByDocumentIdVersionsAndVersionIdShareApiResponse, PostDocumentsByDocumentIdVersionsAndVersionIdShareApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/share`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteDocumentsByDocumentIdVersionsAndVersionIdWorkingDraft: build.mutation<DeleteDocumentsByDocumentIdVersionsAndVersionIdWorkingDraftApiResponse, DeleteDocumentsByDocumentIdVersionsAndVersionIdWorkingDraftApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/working-draft`,
                method: "DELETE",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getDocumentsByDocumentIdVersionsAndVersionIdWorkingDraft: build.query<GetDocumentsByDocumentIdVersionsAndVersionIdWorkingDraftApiResponse, GetDocumentsByDocumentIdVersionsAndVersionIdWorkingDraftApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/working-draft`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchDocumentsByDocumentIdVersionsAndVersionIdWorkingDraft: build.mutation<PatchDocumentsByDocumentIdVersionsAndVersionIdWorkingDraftApiResponse, PatchDocumentsByDocumentIdVersionsAndVersionIdWorkingDraftApiArg>({
            query: (queryArg) => ({
                url: `/documents/${queryArg.documentId}/versions/${queryArg.versionId}/working-draft`,
                method: "PATCH",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWorkflowsAvailable: build.query<GetWorkflowsAvailableApiResponse, GetWorkflowsAvailableApiArg>({
            query: (queryArg) => ({
                url: `/workflows/available`,
                params: { completed: queryArg.completed },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        putWorkflowsParseTemplate: build.mutation<PutWorkflowsParseTemplateApiResponse, PutWorkflowsParseTemplateApiArg>({
            query: (queryArg) => ({
                url: `/workflows/parse-template`,
                method: "PUT",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postWorkflowsByWorkflowIdClone: build.mutation<PostWorkflowsByWorkflowIdCloneApiResponse, PostWorkflowsByWorkflowIdCloneApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}/clone`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchWorkflowsByWorkflowIdDiscardDraft: build.mutation<PatchWorkflowsByWorkflowIdDiscardDraftApiResponse, PatchWorkflowsByWorkflowIdDiscardDraftApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}/discard-draft`,
                method: "PATCH",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWorkflowsByWorkflowIdDownloadAndContentType: build.query<GetWorkflowsByWorkflowIdDownloadAndContentTypeApiResponse, GetWorkflowsByWorkflowIdDownloadAndContentTypeApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}/download/${queryArg.contentType}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postWorkflowsByWorkflowIdDuplicate: build.mutation<PostWorkflowsByWorkflowIdDuplicateApiResponse, PostWorkflowsByWorkflowIdDuplicateApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}/duplicate`,
                method: "POST",
                params: { targetWorkflowId: queryArg.targetWorkflowId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchWorkflowsByWorkflowIdFormData: build.mutation<PatchWorkflowsByWorkflowIdFormDataApiResponse, PatchWorkflowsByWorkflowIdFormDataApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}/form-data`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWorkflowsByParentWorkflowIdIntakeFormLink: build.query<GetWorkflowsByParentWorkflowIdIntakeFormLinkApiResponse, GetWorkflowsByParentWorkflowIdIntakeFormLinkApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.parentWorkflowId}/intake-form/link/`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchWorkflowsByWorkflowIdPublish: build.mutation<PatchWorkflowsByWorkflowIdPublishApiResponse, PatchWorkflowsByWorkflowIdPublishApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}/publish`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWorkflowsByWorkflowIdRemoteTemplateLocation: build.query<GetWorkflowsByWorkflowIdRemoteTemplateLocationApiResponse, GetWorkflowsByWorkflowIdRemoteTemplateLocationApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}/remote/template-location`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchWorkflowsByWorkflowIdSettings: build.mutation<PatchWorkflowsByWorkflowIdSettingsApiResponse, PatchWorkflowsByWorkflowIdSettingsApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}/settings`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchWorkflowsByWorkflowIdUnpublish: build.mutation<PatchWorkflowsByWorkflowIdUnpublishApiResponse, PatchWorkflowsByWorkflowIdUnpublishApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}/unpublish`,
                method: "PATCH",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWorkflowsByWorkflowIdVisibilitySettings: build.query<GetWorkflowsByWorkflowIdVisibilitySettingsApiResponse, GetWorkflowsByWorkflowIdVisibilitySettingsApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}/visibility-settings`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postWorkflowsByWorkflowIdVisibilitySettings: build.mutation<PostWorkflowsByWorkflowIdVisibilitySettingsApiResponse, PostWorkflowsByWorkflowIdVisibilitySettingsApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}/visibility-settings`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        putWorkflowsByWorkflowIdVisibilitySettings: build.mutation<PutWorkflowsByWorkflowIdVisibilitySettingsApiResponse, PutWorkflowsByWorkflowIdVisibilitySettingsApiArg>({
            query: (queryArg) => ({
                url: `/workflows/${queryArg.workflowId}/visibility-settings`,
                method: "PUT",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketsList: build.query<GetTicketsListApiResponse, GetTicketsListApiArg>({
            query: (queryArg) => ({
                url: `/tickets/list`,
                params: {
                    page: queryArg.page,
                    pageSize: queryArg.pageSize,
                    sort: queryArg.sort,
                    filter: queryArg.filter,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketsResolveTicketId: build.query<GetTicketsResolveTicketIdApiResponse, GetTicketsResolveTicketIdApiArg>({
            query: (queryArg) => ({
                url: `/tickets/resolve-ticket-id/`,
                params: { contract_record_unique_id: queryArg.contractRecordUniqueId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketsByTicketIdAttachments: build.query<GetTicketsByTicketIdAttachmentsApiResponse, GetTicketsByTicketIdAttachmentsApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/attachments`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postTicketsByTicketIdCancel: build.mutation<PostTicketsByTicketIdCancelApiResponse, PostTicketsByTicketIdCancelApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/cancel`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketsByTicketIdCheckEnvelope: build.query<GetTicketsByTicketIdCheckEnvelopeApiResponse, GetTicketsByTicketIdCheckEnvelopeApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/check-envelope`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postTicketsByTicketIdCreateEnvelope: build.mutation<PostTicketsByTicketIdCreateEnvelopeApiResponse, PostTicketsByTicketIdCreateEnvelopeApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/create-envelope`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postTicketsByTicketIdNextStage: build.mutation<PostTicketsByTicketIdNextStageApiResponse, PostTicketsByTicketIdNextStageApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/next-stage/`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketsByTicketIdPackagesStatus: build.query<GetTicketsByTicketIdPackagesStatusApiResponse, GetTicketsByTicketIdPackagesStatusApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/packages/status`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketsByTicketIdParticipants: build.query<GetTicketsByTicketIdParticipantsApiResponse, GetTicketsByTicketIdParticipantsApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/participants`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postTicketsByTicketIdParticipants: build.mutation<PostTicketsByTicketIdParticipantsApiResponse, PostTicketsByTicketIdParticipantsApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/participants`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteTicketsByTicketIdParticipantsAndUserId: build.mutation<DeleteTicketsByTicketIdParticipantsAndUserIdApiResponse, DeleteTicketsByTicketIdParticipantsAndUserIdApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/participants/${queryArg.userId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postTicketsByTicketIdShare: build.mutation<PostTicketsByTicketIdShareApiResponse, PostTicketsByTicketIdShareApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/share`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postTicketsByTicketIdSignEnvelope: build.mutation<PostTicketsByTicketIdSignEnvelopeApiResponse, PostTicketsByTicketIdSignEnvelopeApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/sign-envelope`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteTicketsByTicketIdSigners: build.mutation<DeleteTicketsByTicketIdSignersApiResponse, DeleteTicketsByTicketIdSignersApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/signers`,
                method: "DELETE",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketsByTicketIdSigners: build.query<GetTicketsByTicketIdSignersApiResponse, GetTicketsByTicketIdSignersApiArg>({
            query: (queryArg) => ({ url: `/tickets/${queryArg.ticketId}/signers`, rtkQueryOptions: (queryArg as any)?.rtkQueryOptions }),
        }),
        patchTicketsByTicketIdSigners: build.mutation<PatchTicketsByTicketIdSignersApiResponse, PatchTicketsByTicketIdSignersApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/signers`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postTicketsByTicketIdSupplierNegotiation: build.mutation<PostTicketsByTicketIdSupplierNegotiationApiResponse, PostTicketsByTicketIdSupplierNegotiationApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/supplier-negotiation`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketsByTicketIdTurnTrackings: build.query<GetTicketsByTicketIdTurnTrackingsApiResponse, GetTicketsByTicketIdTurnTrackingsApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/turn-trackings`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postTicketsByTicketIdTurnTrackings: build.mutation<PostTicketsByTicketIdTurnTrackingsApiResponse, PostTicketsByTicketIdTurnTrackingsApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/turn-trackings`,
                method: "POST",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchTicketsByTicketIdUpdateEnvelope: build.mutation<PatchTicketsByTicketIdUpdateEnvelopeApiResponse, PatchTicketsByTicketIdUpdateEnvelopeApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/update-envelope`,
                method: "PATCH",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketsByTicketIdWellKnownFields: build.query<GetTicketsByTicketIdWellKnownFieldsApiResponse, GetTicketsByTicketIdWellKnownFieldsApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/well-known-fields/`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchTicketsByTicketIdIssuesAndIssueIdApprove: build.mutation<PatchTicketsByTicketIdIssuesAndIssueIdApproveApiResponse, PatchTicketsByTicketIdIssuesAndIssueIdApproveApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/issues/${queryArg.issueId}/approve/`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchTicketsByTicketIdIssuesAndIssueIdReject: build.mutation<PatchTicketsByTicketIdIssuesAndIssueIdRejectApiResponse, PatchTicketsByTicketIdIssuesAndIssueIdRejectApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/issues/${queryArg.issueId}/reject/`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchTicketsByTicketIdIssuesAndIssueIdReset: build.mutation<PatchTicketsByTicketIdIssuesAndIssueIdResetApiResponse, PatchTicketsByTicketIdIssuesAndIssueIdResetApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/issues/${queryArg.issueId}/reset/`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchTicketsByTicketIdIssuesAndIssueIdReassign: build.mutation<PatchTicketsByTicketIdIssuesAndIssueIdReassignApiResponse, PatchTicketsByTicketIdIssuesAndIssueIdReassignApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/issues/${queryArg.issueId}/reassign/`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketsByTicketIdIssuesAndIssueIdApprovals: build.query<GetTicketsByTicketIdIssuesAndIssueIdApprovalsApiResponse, GetTicketsByTicketIdIssuesAndIssueIdApprovalsApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/issues/${queryArg.issueId}/approvals`,
                params: { entityType: queryArg.entityType },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postTicketsByTicketIdJudgmentResultsAndJudgmentResultIdRemind: build.mutation<PostTicketsByTicketIdJudgmentResultsAndJudgmentResultIdRemindApiResponse, PostTicketsByTicketIdJudgmentResultsAndJudgmentResultIdRemindApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/judgment-results/${queryArg.judgmentResultId}/remind/`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenApprove: build.query<GetTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenApproveApiResponse, GetTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenApproveApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/judgment-results/${queryArg.judgmentResultId}/${queryArg.token}/approve/`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenApprove: build.mutation<PatchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenApproveApiResponse, PatchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenApproveApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/judgment-results/${queryArg.judgmentResultId}/${queryArg.token}/approve/`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenReject: build.query<GetTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenRejectApiResponse, GetTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenRejectApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/judgment-results/${queryArg.judgmentResultId}/${queryArg.token}/reject/`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenReject: build.mutation<PatchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenRejectApiResponse, PatchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenRejectApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/judgment-results/${queryArg.judgmentResultId}/${queryArg.token}/reject/`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchTicketsByTicketIdStagesAndStageId: build.mutation<PatchTicketsByTicketIdStagesAndStageIdApiResponse, PatchTicketsByTicketIdStagesAndStageIdApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/stages/${queryArg.stageId}`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchTicketsByTicketIdStagesAndStageIdResetApprovals: build.mutation<PatchTicketsByTicketIdStagesAndStageIdResetApprovalsApiResponse, PatchTicketsByTicketIdStagesAndStageIdResetApprovalsApiArg>({
            query: (queryArg) => ({
                url: `/tickets/${queryArg.ticketId}/stages/${queryArg.stageId}/reset-approvals`,
                method: "PATCH",
                body: queryArg.body,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetClientsByExtIdOauthTokensAndIntegrationApiResponse = 
/** status 200 ok */ OauthTokenResponse;
export type GetClientsByExtIdOauthTokensAndIntegrationApiArg = {
    /** External client id */
    extId: number;
    /** Return the token corresponding to this integration type. */
    integration: "salesforce" | "docusign" | "adobesign";
};
export type UpdateDocumentApiResponse = unknown;
export type UpdateDocumentApiArg = {
    /** The document UUID. */
    documentId: string;
    /** Update document name by uuid */
    body: {
        name?: string;
    };
};
export type CreateVersionApiResponse = unknown;
export type CreateVersionApiArg = {
    /** The document ID. */
    documentId: string;
    text?: string;
    body: {
        file?: Blob;
    };
};
export type GetAllVersionsApiResponse = Version[];
export type GetAllVersionsApiArg = {
    /** The document ID. */
    documentId: string;
};
export type GetVersionApiResponse = Version[];
export type GetVersionApiArg = {
    /** The document ID. */
    documentId: string;
    /** The version ID. */
    versionId: string;
};
export type DeleteVersionApiResponse = unknown;
export type DeleteVersionApiArg = {
    /** The document ID. */
    documentId: string;
    /** The version ID. */
    versionId: string;
};
export type CreateVersionBackupApiResponse = 
/** status 201 Created */ VersionBackup;
export type CreateVersionBackupApiArg = {
    /** The document ID. */
    documentId: string;
    /** The version ID. */
    versionId: string;
    body: {
        file?: Blob;
        file_type?: string;
    };
};
export type DownloadVersionApiResponse = unknown;
export type DownloadVersionApiArg = {
    /** The document ID. */
    documentId: string;
    /** The version ID. */
    versionId: string;
    /** The file type to download */
    fileType: string;
};
export type AddWorkflowApiResponse = {
    id?: string;
};
export type AddWorkflowApiArg = void;
export type GetAllWorkflowsApiResponse = {
    count?: number;
    result?: {
        id?: string;
        name?: string;
        createdBy?: string;
        createdDate?: number;
        modifiedDate?: number;
        published?: boolean;
    }[];
};
export type GetAllWorkflowsApiArg = {
    completed?: boolean;
    published?: boolean;
};
export type GetWorkflowApiResponse = Workflow;
export type GetWorkflowApiArg = {
    /** id of requested workflow */
    workflowId: string;
};
export type PatchWorkflowsByWorkflowIdApiResponse = unknown;
export type PatchWorkflowsByWorkflowIdApiArg = {
    workflowId: string;
    /** specific fields to be updated */
    body: object;
};
export type DeleteWorkflowApiResponse = unknown;
export type DeleteWorkflowApiArg = {
    workflowId: string;
};
export type CreateTicketPackageApiResponse = 
/** status 200 Sender view URL for the created package. */ LinksResponse;
export type CreateTicketPackageApiArg = {
    /** Ticket identifier. */
    ticketId: string;
    createTicketPackageRequest: CreateTicketPackageRequest;
};
export type GetTicketPackageRecipientsApiResponse = 
/** status 200 Package recipients. */ GetPackageRecipientsResponse;
export type GetTicketPackageRecipientsApiArg = {
    /** Ticket identifier. */
    ticketId: string;
};
export type GetTicketPackageActivitiesApiResponse = 
/** status 200 Package activities. */ GetPackageActivitiesResponse;
export type GetTicketPackageActivitiesApiArg = {
    /** Ticket identifier. */
    ticketId: string;
};
export type SignTicketPackageApiResponse = 
/** status 200 Signer view URL. */ LinksResponse;
export type SignTicketPackageApiArg = {
    /** Ticket identifier. */
    ticketId: string;
    signTicketPackageRequest: SignTicketPackageRequest;
};
export type ViewTicketPackageApiResponse = 
/** status 200 Console view URL. */ LinksResponse;
export type ViewTicketPackageApiArg = {
    /** Ticket identifier. */
    ticketId: string;
    viewTicketPackageRequest: ViewTicketPackageRequest;
};
export type RemindTicketPackageRecipientApiResponse = 
/** status 200 Reminder details. */ RemindSignerResponse;
export type RemindTicketPackageRecipientApiArg = {
    /** Ticket identifier. */
    ticketId: string;
    remindSignerRequest: RemindSignerRequest;
};
export type GetInitialSignersApiResponse = 
/** status 200 Initial signers. */ GetInitialSignersResponse;
export type GetInitialSignersApiArg = {
    /** Ticket identifier. */
    ticketId: string;
};
export type ReassignInitialSignerApiResponse = 
/** status 200 Updated initial signers. */ GetInitialSignersResponse;
export type ReassignInitialSignerApiArg = {
    /** Ticket identifier. */
    ticketId: string;
    reassignInitialSignerRequest: ReassignInitialSignerRequest;
};
export type GetEsignaturesApiResponse = 
/** status 200 OK */ ESignatureResponseRead[];
export type GetEsignaturesApiArg = void;
export type PostEsignaturesApiResponse = 
/** status 201 Successfully created an esignature integration */ ESignatureResponseRead[];
export type PostEsignaturesApiArg = {
    /** the data to create the esignature integration record */
    eSignatureRequest: ESignatureRequest;
};
export type DeleteEsignaturesByEsignatureIdApiResponse = unknown;
export type DeleteEsignaturesByEsignatureIdApiArg = {
    /** ID of the esignature integration */
    esignatureId: string;
};
export type GetEsignaturesByEsignatureIdApiResponse = 
/** status 200 OK */ ESignatureResponseRead;
export type GetEsignaturesByEsignatureIdApiArg = {
    /** ID of the esignature integration */
    esignatureId: string;
};
export type PatchEsignaturesByEsignatureIdApiResponse = 
/** status 200 OK */ ESignatureResponseRead[];
export type PatchEsignaturesByEsignatureIdApiArg = {
    /** ID of the esignature integration */
    esignatureId: string;
    /** the data to update on the esignature integration record */
    eSignatureRequest: ESignatureRequest;
};
export type GetEsignaturesCheckApiResponse = 
/** status 200 OK */ HasESignaturesResponse;
export type GetEsignaturesCheckApiArg = void;
export type AddIntakeFormApiResponse = 
/** status 201 Successful response */ IntakeFormRes;
export type AddIntakeFormApiArg = {
    /** the intake form to create */
    intakeFormReq: IntakeFormReq;
};
export type AddTicketApiResponse = 
/** status 201 Successful response */ TicketRes;
export type AddTicketApiArg = {
    body: {
        file?: Blob;
        intakeForm?: TicketReq;
        turnTracking?: TurnTrackingReq;
    };
};
export type GetTicketApiResponse = GetTicketRes;
export type GetTicketApiArg = {
    /** the ID of the ticket */
    ticketId: string;
};
export type UpdateTicketApiResponse = 
/** status 201 Successful response */ GetTicketRes;
export type UpdateTicketApiArg = {
    /** the ID of the ticket */
    ticketId: string;
    /** the ticket data to update */
    body: {
        name?: string;
        fields?: IntakeFormFieldValue[];
    };
};
export type DeleteTicketApiResponse = unknown;
export type DeleteTicketApiArg = {
    /** the ID of the ticket */
    ticketId: string;
};
export type PatchTicketsByTicketIdApiResponse = {};
export type PatchTicketsByTicketIdApiArg = {
    ticketId: string;
    body: {
        name: string;
    };
};
export type TicketCompleteApiResponse = 
/** status 200 Successful response */ TicketRes;
export type TicketCompleteApiArg = {
    /** the ID of the ticket */
    ticketId: string;
};
export type UploadSignedApiResponse = unknown;
export type UploadSignedApiArg = {
    /** The ticket ID. */
    ticketId: string;
    text?: string;
    body: {
        signerIds?: (string | number)[];
        file?: Blob;
    };
};
export type UpdateTurnTrackingApiResponse = unknown;
export type UpdateTurnTrackingApiArg = {
    ticketId: string;
    turnId: string;
    /** the turn tracking data to update */
    turnTrackingEditReq: TurnTrackingEditReq;
};
export type GetTicketIntakeFormApiResponse = 
/** status 200 the response */ IntakeFormRes[];
export type GetTicketIntakeFormApiArg = {
    /** the ID of the ticket */
    ticketId: string;
};
export type PatchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdApiResponse = 
/** status 200 Judgment result updated successfully */ {};
export type PatchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdApiArg = {
    ticketId: string;
    judgmentResultId: string;
    /** the judgment result data to update */
    judgmentResultReq: JudgmentResultReq;
};
export type GetTicketsByTicketIdApprovalsApiResponse = 
/** status 200 the response */ TicketPhase[];
export type GetTicketsByTicketIdApprovalsApiArg = {
    /** the ID of the ticket */
    ticketId: string;
};
export type BackToReviewApiResponse = TicketReq;
export type BackToReviewApiArg = {
    /** the ID of the ticket */
    ticketId: string;
};
export type GetDocumentDetailsApiResponse = 
/** status 200 the response */ DocumentDetails;
export type GetDocumentDetailsApiArg = {
    /** the ID of the ticket */
    ticketId: string;
};
export type GetTicketSummaryApiResponse = 
/** status 200 a summary of the ticket */ TicketSummary;
export type GetTicketSummaryApiArg = {
    /** the ID of the ticket */
    ticketId: string;
};
export type GetTicketCurrentStageDetailsApiResponse = 
/** status 200 current stage details of the ticket */ TicketStage;
export type GetTicketCurrentStageDetailsApiArg = {
    /** the ID of the ticket */
    ticketId: string;
};
export type GetPermissionsAccesibilityApiResponse = 
/** status 200 the response */ PermissionsMap;
export type GetPermissionsAccesibilityApiArg = {
    permissionsBody: PermissionsBody;
};
export type CreateRoutingApiResponse = 
/** status 201 Routing created successfully */ RoutingResponse;
export type CreateRoutingApiArg = {
    routingCreateRequest: RoutingCreateRequest;
};
export type SearchRoutingApiResponse = 
/** status 200 Search results returned successfully */ RoutingSearchResponse;
export type SearchRoutingApiArg = {
    /** Number of items per page */
    pageSize?: number;
    /** Current page number (1-indexed) */
    currentPage?: number;
    /** Search string to filter results by routeName or instructions */
    searchString?: string;
    /** Sort criteria in format "+column" or "-column" (e.g., "+routeName,-modifiedDate") */
    orderBy?: string;
};
export type GetRoutingByIdApiResponse = 
/** status 200 Routing entry returned successfully */ RoutingResponse;
export type GetRoutingByIdApiArg = {
    /** Routing entry UUID */
    routingId: string;
};
export type UpdateRoutingApiResponse = 
/** status 200 Routing updated successfully */ RoutingResponse;
export type UpdateRoutingApiArg = {
    /** Routing entry UUID */
    routingId: string;
    routingUpdateRequest: RoutingUpdateRequest;
};
export type DeleteRoutingApiResponse = 
/** status 204 Routing deleted successfully */ void;
export type DeleteRoutingApiArg = {
    /** Routing entry UUID */
    routingId: string;
};
export type GetUnroutedWorkflowsApiResponse = 
/** status 200 List of unrouted workflows returned successfully */ {
    data?: UnroutedWorkflow[];
};
export type GetUnroutedWorkflowsApiArg = void;
export type GetRoutingConfigurationApiResponse = 
/** status 200 Routing configuration returned successfully. Returns default empty record if no configuration exists. */ RoutingConfigurationResponse;
export type GetRoutingConfigurationApiArg = void;
export type PatchRoutingConfigurationApiResponse = 
/** status 200 Routing configuration updated successfully */
RoutingConfigurationResponse | /** status 201 Routing configuration created successfully */ RoutingConfigurationResponse;
export type PatchRoutingConfigurationApiArg = {
    routingConfigurationPatchRequest: RoutingConfigurationPatchRequest;
};
export type GetActivationStatusApiResponse = 
/** status 200 Activation status returned successfully */ ActivationStatusResponse;
export type GetActivationStatusApiArg = void;
export type GetWorkflowPartiesApiResponse = 
/** status 200 success */ TurnTrackingPartiesRes;
export type GetWorkflowPartiesApiArg = {
    workflowId: string;
};
export type GetActivitiesApiResponse = {
    id?: string;
    type?: string;
    message?: string;
    createdDate?: string;
}[];
export type GetActivitiesApiArg = {
    /** The type of entity to fetch activities for. */
    entityType: string;
    /** The id of the entity to fetch activities for. */
    entityId: string;
};
export type PostActivitiesApiResponse = {
    detail?: string;
};
export type PostActivitiesApiArg = {
    body: {
        type: "OODOCS_DOWNLOAD_DOCUMENT" | "OODOCS_DOWNLOAD_REDLINE" | "DOCUMENT_UNLOCK" | "DOCUMENT_EDIT";
        ticketId?: string;
        versionId?: string;
        versionNumber?: number;
        documentId?: string;
        isGenerated?: boolean;
        referenceVersionId?: string;
        targetVersionId?: string;
    };
};
export type GetActivitiesTokenizeApiResponse = {};
export type GetActivitiesTokenizeApiArg = {
    /** JSON-encoded list of text strings to search within. */
    textList: string;
    highlightsIndex: number;
    riskId: string;
};
export type PostActivitiesTokenizeApiResponse = {};
export type PostActivitiesTokenizeApiArg = {
    /** JSON-encoded list of text strings to search within. */
    textList: string;
    highlightsIndex: number;
    riskId: string;
};
export type GetAdobesignAuthorizeApiResponse = unknown;
export type GetAdobesignAuthorizeApiArg = {
    /** Base64url-encoded session-state id. */
    state: string;
};
export type GetAdobesignWebhookApiResponse = {
    detail?: string;
};
export type GetAdobesignWebhookApiArg = void;
export type PostAdobesignWebhookApiResponse = {
    detail?: string;
};
export type PostAdobesignWebhookApiArg = {
    body: {
        agreement: {
            id?: string;
        };
    };
};
export type GetDsAuthorizeApiResponse = unknown;
export type GetDsAuthorizeApiArg = {
    /** Base64url-encoded session-state id. */
    state: string;
};
export type PostDsWebhookApiResponse = {
    detail?: string;
};
export type PostDsWebhookApiArg = void;
export type PostSalesforceLoginApiResponse = {
    redirectUrl?: string;
};
export type PostSalesforceLoginApiArg = {
    body: {
        integrationUrl?: string;
    };
};
export type GetSalesforceAuthorizeApiResponse = unknown;
export type GetSalesforceAuthorizeApiArg = {
    state: string;
};
export type PostAttachmentsApiResponse = {
    id?: string;
    fileName?: string;
    fileType?: string;
    lastUpdated?: string;
    fileSize?: number;
    userId?: number;
};
export type PostAttachmentsApiArg = {
    body: {
        file: Blob;
        intake_form_field_id?: string;
    };
};
export type GetAttachmentsByAttachmentIdApiResponse = unknown;
export type GetAttachmentsByAttachmentIdApiArg = {
    /** Attachment UUID. */
    attachmentId: string;
};
export type PostClientsPermissionsVersionsByVersionIdApiResponse = 
/** status 200 OK */ {
    entity_type?: string;
    entity_id?: string;
    user_permission_map?: {
        [key: string]: {
            permission_type?: string;
            has_access?: boolean;
        };
    };
};
export type PostClientsPermissionsVersionsByVersionIdApiArg = {
    versionId: string;
    body: {
        userIds?: number[];
    };
};
export type GetClientsByClientExtIdOauthTokensAndProviderProviderIdApiResponse = 
/** status 200 OK */ {
    organization_id?: string;
    access_token?: string;
    base_path?: string;
    token_expiration?: string;
};
export type GetClientsByClientExtIdOauthTokensAndProviderProviderIdApiArg = {
    /** External client id. */
    clientExtId: string;
    /** Integration type, e.g. salesforce, docusign, adobesign. */
    provider: string;
    /** Provider-specific id, or 'default' to use the default token. */
    providerId: string;
};
export type GetCompaniesApiResponse = {
    data?: {
        type?: string;
        id?: string;
        attributes?: {
            descriptor?: string;
            id?: string;
            Organization_Reference_ID?: string;
        };
    }[];
    meta?: {
        limit?: number;
        offset?: number;
        total?: number;
    };
    links?: {
        self?: string;
        first?: string;
        prev?: string;
        next?: string;
        last?: string;
    };
};
export type GetCompaniesApiArg = {
    /** Search query; minimum length enforced server-side. */
    q: string;
    /** Max results per page. */
    limit?: number;
    /** Pagination offset. */
    offset?: number;
};
export type GetContractTypesApiResponse = {
    data?: {
        type?: string;
        id?: string;
        attributes?: {
            descriptor?: string;
            id?: string;
            Supplier_Contract_Type_ID?: string;
            linked_workflow_id?: string;
        };
    }[];
    meta?: {
        limit?: number;
        offset?: number;
        total?: number;
    };
    links?: {
        self?: string;
        first?: string;
        prev?: string;
        next?: string;
        last?: string;
    };
};
export type GetContractTypesApiArg = {
    /** Max results per page. */
    limit?: number;
    /** Pagination offset. */
    offset?: number;
};
export type GetCurrenciesApiResponse = {
    data?: {
        type?: string;
        id?: string;
        attributes?: {
            code?: string;
        };
    }[];
    meta?: {
        total?: number;
    };
};
export type GetCurrenciesApiArg = void;
export type GetCrmsApiResponse = {
    data?: CrmResponseRead[];
};
export type GetCrmsApiArg = void;
export type DeleteCrmsByCrmIdApiResponse = unknown;
export type DeleteCrmsByCrmIdApiArg = {
    /** CRM record id. */
    crmId: string;
};
export type PostEsignaturesUserApiResponse = 
/** status 200 OK */ ESignatureLoggedInResponse;
export type PostEsignaturesUserApiArg = {
    /** Used to build a login redirect URL when the user needs to re-authenticate. */
    body: {
        integrationUrl?: string;
        ticketId?: string;
        ticketUrl?: string;
    };
};
export type PostEsignaturesByEsignatureIdLoginApiResponse = 
/** status 200 OK */ RedirectUrl;
export type PostEsignaturesByEsignatureIdLoginApiArg = {
    esignatureId: string;
    body: {
        integrationUrl?: string;
        ticketId?: string;
        ticketUrl?: string;
    };
};
export type GetSuppliersBySupplierIdApiResponse = {
    data?: {
        type?: string;
        id?: string;
        attributes?: {
            wid?: string;
            name?: string;
            external_status?: string;
            segmentation?: string;
            risk?: string;
        };
    };
    included?: {
        type?: string;
        id?: string;
        attributes?: {
            name?: string;
            first_name?: string;
            last_name?: string;
            email?: string;
            contact_types?: {
                id?: number;
                name?: string;
            }[];
        };
    }[];
};
export type GetSuppliersBySupplierIdApiArg = {
    /** WSS supplier company id. */
    supplierId: string;
    includeContacts?: boolean;
};
export type GetIntegrateWorkflowByParentWorkflowIdIntakeFormLinkApiResponse = 
/** status 200 OK */ IntakeFormRes;
export type GetIntegrateWorkflowByParentWorkflowIdIntakeFormLinkApiArg = {
    parentWorkflowId: string;
    /** Optional reference id used to populate supplier/contract-type well-known fields. */
    referenceId?: string;
};
export type GetIntegrateWorkflowByParentWorkflowIdSuppliersApiResponse = 
/** status 200 OK */ {
    data?: {
        type?: string;
        id?: string;
        attributes?: {
            wid?: string;
            name?: string;
            external_status?: string;
            segmentation?: string;
            risk?: string;
        };
    }[];
    meta?: {
        total?: number;
        page?: {
            number?: number;
            size?: number;
        };
    };
    links?: {
        self?: string;
        first?: string;
        prev?: string;
        next?: string;
        last?: string;
    };
};
export type GetIntegrateWorkflowByParentWorkflowIdSuppliersApiArg = {
    parentWorkflowId: string;
    /** Search query, minimum 2 characters. */
    q: string;
    page?: {
        number?: number;
        size?: number;
    };
};
export type GetIntegrateWorkflowAmendByContractRecordUniqueIdIntakeFormApiResponse = 
/** status 200 OK */ IntakeFormRes;
export type GetIntegrateWorkflowAmendByContractRecordUniqueIdIntakeFormApiArg = {
    /** Buyer Hub contract record unique id. */
    contractRecordUniqueId: string;
};
export type PostPermissionsCheckUserAccessibilityApiResponse = 
/** status 200 OK */ {
    entity_type?: string;
    entity_id?: string;
    user_permission_map?: {
        [key: string]: {
            permission_type?: string;
            has_access?: boolean;
        };
    };
};
export type PostPermissionsCheckUserAccessibilityApiArg = {
    body: {
        userIds?: number[];
        entityType?: string;
        entityId?: string;
    };
};
export type PostPermissionsVersionsByVersionIdApiResponse = 
/** status 200 OK */ {
    entity_type?: string;
    entity_id?: string;
    user_permission_map?: {
        [key: string]: {
            permission_type?: string;
            has_access?: boolean;
        };
    };
};
export type PostPermissionsVersionsByVersionIdApiArg = {
    versionId: string;
    body: {
        userIds?: number[];
    };
};
export type PostPermissionsVersionsByVersionIdCheckDocViewPermissionApiResponse = 
/** status 200 OK */ {
    entity_type?: string;
    entity_id?: string;
    user_permission_map?: {
        [key: string]: {
            permission_type?: string;
            has_access?: boolean;
        };
    };
};
export type PostPermissionsVersionsByVersionIdCheckDocViewPermissionApiArg = {
    versionId: string;
    body: {
        userIds?: number[];
    };
};
export type PostPackagesMultiTicketValidateApiResponse = {
    is_valid?: boolean;
    message?: string;
    tickets?: {}[];
};
export type PostPackagesMultiTicketValidateApiArg = {
    body: {
        ticket_ids: string[];
        vendor?: string;
    };
};
export type PostPackagesMultiTicketApiResponse = {};
export type PostPackagesMultiTicketApiArg = {
    body: {
        ticket_ids: string[];
        return_url: string;
        vendor: string;
    };
};
export type GetInternalAstroActiveSalesforceIntegrationsApiResponse = 
/** status 200 OK */ {
    data?: {}[];
};
export type GetInternalAstroActiveSalesforceIntegrationsApiArg = void;
export type GetInternalDocumentsByDocumentIdPermissionsApiResponse = 
/** status 200 OK */ {
    [key: string]: {
        canEdit?: boolean;
        canView?: boolean;
    };
};
export type GetInternalDocumentsByDocumentIdPermissionsApiArg = {
    documentId: string;
    userIds: number[];
};
export type GetInternalDocumentsByDocumentIdSummaryApiResponse = 
/** status 200 OK */ {};
export type GetInternalDocumentsByDocumentIdSummaryApiArg = {
    documentId: string;
};
export type GetInternalDocumentsByDocumentIdVersionsAndVersionIdApiResponse = 
/** status 200 OK */ {
    createdById?: string;
    cloudLocations?: object;
    storedCloudLocations?: object;
    sfdtHasUserEdits?: boolean;
    documentId?: string;
    fileSize?: number;
    fileType?: string;
    id?: string;
    name?: string;
    tag?: string;
};
export type GetInternalDocumentsByDocumentIdVersionsAndVersionIdApiArg = {
    documentId: string;
    versionId: string;
    /** File storage location key; defaults to the original location. */
    locationKey?: string;
    evisortClientId: string;
};
export type PatchInternalDocumentsByDocumentIdVersionsAndVersionIdLocationsKeyApiResponse = 
/** status 200 OK */ object;
export type PatchInternalDocumentsByDocumentIdVersionsAndVersionIdLocationsKeyApiArg = {
    documentId: string;
    versionId: string;
    /** File storage type key, e.g. wopi/sharepoint. */
    key: string;
    evisortClientId: string;
    evisortUserId: string;
    /** JSON-encoded list of external editor user ids. */
    evisortEditorsId: string;
    body: {
        cloud_location: any;
    };
};
export type GetInternalTicketsByTicketIdSummaryApiResponse = 
/** status 200 OK */ {};
export type GetInternalTicketsByTicketIdSummaryApiArg = {
    ticketId: string;
};
export type PostInternalVersionsByVersionIdCheckDocViewPermissionApiResponse = 
/** status 200 OK */ {
    entity_type?: string;
    entity_id?: string;
    user_permission_map?: {
        [key: string]: {
            permission_type?: string;
            has_access?: boolean;
        };
    };
};
export type PostInternalVersionsByVersionIdCheckDocViewPermissionApiArg = {
    versionId: string;
    body: {
        userIds?: number[];
    };
};
export type PostDocumentsByDocumentIdVersionsCompareApiResponse = unknown;
export type PostDocumentsByDocumentIdVersionsCompareApiArg = {
    documentId: string;
    body: {
        referenceVersionId: string;
        targetVersionId: string;
    };
};
export type PostDocumentsByDocumentIdVersionsAndVersionIdBumpVersionApiResponse = 
/** status 201 Created */ {
    id?: string;
    fileType?: string;
    versionNumber?: number;
    lastUpdated?: string;
    userId?: number;
    isGenerated?: boolean;
    isCounterparty?: boolean;
    referenceVersionId?: string;
    targetVersionId?: string;
    hasWorkingDraft?: boolean;
    fileSize?: number;
    inboundAttachmentSenderEmail?: string;
    hasAi?: boolean;
    name?: string;
};
export type PostDocumentsByDocumentIdVersionsAndVersionIdBumpVersionApiArg = {
    documentId: string;
    versionId: string;
};
export type PostDocumentsByDocumentIdVersionsAndVersionIdCommentsCommentIdApiResponse = 
/** status 200 OK */ {
    /** Serialized inline comment. */
    data?: {};
};
export type PostDocumentsByDocumentIdVersionsAndVersionIdCommentsCommentIdApiArg = {
    documentId: string;
    versionId: string;
    commentId: string;
    body: {
        usersFromLatestMessage?: number[];
        usersFromPreviousComments?: number[];
        message?: string;
        highlightedText?: string;
    };
};
export type PostDocumentsByDocumentIdVersionsAndVersionIdConvertToDocxApiResponse = 
/** status 201 Created */ {
    id?: string;
    fileType?: string;
    versionNumber?: number;
    lastUpdated?: string;
    userId?: number;
    isGenerated?: boolean;
    isCounterparty?: boolean;
    referenceVersionId?: string;
    targetVersionId?: string;
    hasWorkingDraft?: boolean;
    fileSize?: number;
    inboundAttachmentSenderEmail?: string;
    hasAi?: boolean;
    name?: string;
};
export type PostDocumentsByDocumentIdVersionsAndVersionIdConvertToDocxApiArg = {
    documentId: string;
    versionId: string;
};
export type GetDocumentsByDocumentIdVersionsAndVersionIdDownloadEmailAttachmentApiResponse = 
/** status 200 OK */ {
    url?: string;
};
export type GetDocumentsByDocumentIdVersionsAndVersionIdDownloadEmailAttachmentApiArg = {
    documentId: string;
    versionId: string;
};
export type GetDocumentsByDocumentIdVersionsAndVersionIdDownloadFileApiResponse = unknown;
export type GetDocumentsByDocumentIdVersionsAndVersionIdDownloadFileApiArg = {
    documentId: string;
    versionId: string;
    isSharepointDownload?: boolean;
    isWorkingDraft?: boolean;
};
export type GetDocumentsByDocumentIdVersionsAndVersionIdEditorKeyApiResponse = 
/** status 200 OK */ {
    key?: string;
};
export type GetDocumentsByDocumentIdVersionsAndVersionIdEditorKeyApiArg = {
    documentId: string;
    versionId: string;
};
export type PatchDocumentsByDocumentIdVersionsAndVersionIdEditorKeyApiResponse = 
/** status 200 OK */ {
    id?: string;
    fileType?: string;
    versionNumber?: number;
    lastUpdated?: string;
    userId?: number;
    isGenerated?: boolean;
    isCounterparty?: boolean;
    referenceVersionId?: string;
    targetVersionId?: string;
    hasWorkingDraft?: boolean;
    fileSize?: number;
    inboundAttachmentSenderEmail?: string;
    hasAi?: boolean;
    name?: string;
};
export type PatchDocumentsByDocumentIdVersionsAndVersionIdEditorKeyApiArg = {
    documentId: string;
    versionId: string;
};
export type GetDocumentsByDocumentIdVersionsAndVersionIdRemoteLocationApiResponse = 
/** status 200 OK */ {
    bucket?: string;
    key?: string;
};
export type GetDocumentsByDocumentIdVersionsAndVersionIdRemoteLocationApiArg = {
    documentId: string;
    versionId: string;
};
export type PostDocumentsByDocumentIdVersionsAndVersionIdSfdtApiResponse = 
/** status 200 OK */ {
    id?: string;
    fileType?: string;
    versionNumber?: number;
    lastUpdated?: string;
    userId?: number;
    isGenerated?: boolean;
    isCounterparty?: boolean;
    referenceVersionId?: string;
    targetVersionId?: string;
    hasWorkingDraft?: boolean;
    fileSize?: number;
    inboundAttachmentSenderEmail?: string;
    hasAi?: boolean;
    name?: string;
};
export type PostDocumentsByDocumentIdVersionsAndVersionIdSfdtApiArg = {
    documentId: string;
    versionId: string;
    isDoneEditing?: boolean;
    body: {
        file: Blob;
    };
};
export type PostDocumentsByDocumentIdVersionsAndVersionIdShareApiResponse = 
/** status 200 OK */ {
    detail?: string;
};
export type PostDocumentsByDocumentIdVersionsAndVersionIdShareApiArg = {
    documentId: string;
    versionId: string;
    body: {
        emailsTo: string[];
        emailsCc?: string[];
        emailsBcc?: string[];
        subject?: string;
        body?: string;
    };
};
export type DeleteDocumentsByDocumentIdVersionsAndVersionIdWorkingDraftApiResponse = 
/** status 200 OK */ {};
export type DeleteDocumentsByDocumentIdVersionsAndVersionIdWorkingDraftApiArg = {
    documentId: string;
    versionId: string;
    body: {
        editorKeySuffix: string;
    };
};
export type GetDocumentsByDocumentIdVersionsAndVersionIdWorkingDraftApiResponse = 
/** status 200 OK */ {
    bucket?: string;
    key?: string;
};
export type GetDocumentsByDocumentIdVersionsAndVersionIdWorkingDraftApiArg = {
    documentId: string;
    versionId: string;
};
export type PatchDocumentsByDocumentIdVersionsAndVersionIdWorkingDraftApiResponse = 
/** status 200 OK */ {};
export type PatchDocumentsByDocumentIdVersionsAndVersionIdWorkingDraftApiArg = {
    documentId: string;
    versionId: string;
};
export type GetWorkflowsAvailableApiResponse = {}[];
export type GetWorkflowsAvailableApiArg = {
    /** Filter by completed status. */
    completed?: boolean;
};
export type PutWorkflowsParseTemplateApiResponse = {};
export type PutWorkflowsParseTemplateApiArg = {
    body: {
        file: Blob;
    };
};
export type PostWorkflowsByWorkflowIdCloneApiResponse = 
/** status 201 Created */ {};
export type PostWorkflowsByWorkflowIdCloneApiArg = {
    workflowId: string;
    body: {
        target_client_id: number;
        target_workflow_id?: string;
    };
};
export type PatchWorkflowsByWorkflowIdDiscardDraftApiResponse = 
/** status 200 OK */ {};
export type PatchWorkflowsByWorkflowIdDiscardDraftApiArg = {
    workflowId: string;
};
export type GetWorkflowsByWorkflowIdDownloadAndContentTypeApiResponse = unknown;
export type GetWorkflowsByWorkflowIdDownloadAndContentTypeApiArg = {
    workflowId: string;
    /** File storage type, e.g. original/sfdt. */
    contentType: string;
};
export type PostWorkflowsByWorkflowIdDuplicateApiResponse = 
/** status 201 Created */ {};
export type PostWorkflowsByWorkflowIdDuplicateApiArg = {
    workflowId: string;
    /** Existing workflow id to duplicate into, if replacing a draft. */
    targetWorkflowId?: string;
};
export type PatchWorkflowsByWorkflowIdFormDataApiResponse = 
/** status 200 OK */ {};
export type PatchWorkflowsByWorkflowIdFormDataApiArg = {
    workflowId: string;
    body: {
        /** JSON-encoded prefillable intake form data. */
        payload: string;
    };
};
export type GetWorkflowsByParentWorkflowIdIntakeFormLinkApiResponse = 
/** status 200 OK */ IntakeFormRes;
export type GetWorkflowsByParentWorkflowIdIntakeFormLinkApiArg = {
    parentWorkflowId: string;
};
export type PatchWorkflowsByWorkflowIdPublishApiResponse = 
/** status 200 OK */ {};
export type PatchWorkflowsByWorkflowIdPublishApiArg = {
    workflowId: string;
    body: {
        /** JSON-encoded workflow update data, applied before publishing. */
        payload?: string;
        file?: Blob;
    };
};
export type GetWorkflowsByWorkflowIdRemoteTemplateLocationApiResponse = 
/** status 200 OK */ {
    bucket?: string;
    key?: string;
};
export type GetWorkflowsByWorkflowIdRemoteTemplateLocationApiArg = {
    workflowId: string;
};
export type PatchWorkflowsByWorkflowIdSettingsApiResponse = 
/** status 200 OK */ {
    archiveLocation?: object;
    permissions?: object;
    dataFieldsMapping?: object[];
    notifications?: object[];
    ticketNamingConvention?: string;
    keepSystemDefaultTicketName?: boolean;
    isTurnTrackingEnabled?: boolean;
};
export type PatchWorkflowsByWorkflowIdSettingsApiArg = {
    workflowId: string;
    body: {};
};
export type PatchWorkflowsByWorkflowIdUnpublishApiResponse = 
/** status 200 OK */ {};
export type PatchWorkflowsByWorkflowIdUnpublishApiArg = {
    workflowId: string;
};
export type GetWorkflowsByWorkflowIdVisibilitySettingsApiResponse = 
/** status 200 OK */ {
    data?: {
        type?: string;
        id?: string;
        attributes?: {
            user_ids?: number[];
            department_ids?: number[];
        };
    };
};
export type GetWorkflowsByWorkflowIdVisibilitySettingsApiArg = {
    workflowId: string;
};
export type PostWorkflowsByWorkflowIdVisibilitySettingsApiResponse = 
/** status 201 Created */ {
    data?: {
        type?: string;
        id?: string;
        attributes?: {
            user_ids?: number[];
            department_ids?: number[];
        };
    };
};
export type PostWorkflowsByWorkflowIdVisibilitySettingsApiArg = {
    workflowId: string;
    body: {
        data?: {
            type?: string;
            attributes?: {
                user_ids?: number[];
                department_ids?: number[];
            };
        };
    };
};
export type PutWorkflowsByWorkflowIdVisibilitySettingsApiResponse = 
/** status 200 OK */ {
    data?: {
        type?: string;
        id?: string;
        attributes?: {
            user_ids?: number[];
            department_ids?: number[];
        };
    };
};
export type PutWorkflowsByWorkflowIdVisibilitySettingsApiArg = {
    workflowId: string;
    body: {
        data?: {
            type?: string;
            attributes?: {
                user_ids?: number[];
                department_ids?: number[];
            };
        };
    };
};
export type GetTicketsListApiResponse = {
    data?: {}[];
    count?: number;
};
export type GetTicketsListApiArg = {
    page?: number;
    /** -1 returns all results. */
    pageSize?: number;
    /** Comma-separated fields, prefixed with + or -, e.g. '+name,+modifiedDate'. */
    sort?: string;
    /** Filter expression. */
    filter?: string;
};
export type GetTicketsResolveTicketIdApiResponse = {
    ticket_id?: string;
    is_completed?: boolean;
};
export type GetTicketsResolveTicketIdApiArg = {
    contractRecordUniqueId: string;
};
export type GetTicketsByTicketIdAttachmentsApiResponse = {
    userId?: number;
    createdAt?: string;
    fileName?: string;
    fileType?: string;
    fileSize?: number;
    id?: string;
}[];
export type GetTicketsByTicketIdAttachmentsApiArg = {
    ticketId: string;
};
export type PostTicketsByTicketIdCancelApiResponse = {
    cancelledDate?: string;
    esigErrorMessage?: string;
};
export type PostTicketsByTicketIdCancelApiArg = {
    ticketId: string;
    body: {
        reason?: string;
    };
};
export type GetTicketsByTicketIdCheckEnvelopeApiResponse = 
/** status 200 OK */ {
    data?: boolean;
};
export type GetTicketsByTicketIdCheckEnvelopeApiArg = {
    ticketId: string;
};
export type PostTicketsByTicketIdCreateEnvelopeApiResponse = 
/** status 200 OK */ RedirectUrl;
export type PostTicketsByTicketIdCreateEnvelopeApiArg = {
    ticketId: string;
    body: {
        ticketUrl: string;
    };
};
export type PostTicketsByTicketIdNextStageApiResponse = {};
export type PostTicketsByTicketIdNextStageApiArg = {
    ticketId: string;
};
export type GetTicketsByTicketIdPackagesStatusApiResponse = 
/** status 200 OK */ {
    data?: {
        id?: string;
        type?: string;
        attributes?: {
            status?: string;
        };
    };
};
export type GetTicketsByTicketIdPackagesStatusApiArg = {
    ticketId: string;
};
export type GetTicketsByTicketIdParticipantsApiResponse = {
    data?: {}[];
};
export type GetTicketsByTicketIdParticipantsApiArg = {
    ticketId: string;
};
export type PostTicketsByTicketIdParticipantsApiResponse = 
/** status 200 OK */ {
    data?: {}[];
};
export type PostTicketsByTicketIdParticipantsApiArg = {
    ticketId: string;
    body: {
        type?: "department" | "user";
        typeIds?: number[];
        userIds?: number[];
    };
};
export type DeleteTicketsByTicketIdParticipantsAndUserIdApiResponse = 
/** status 200 OK */ {};
export type DeleteTicketsByTicketIdParticipantsAndUserIdApiArg = {
    ticketId: string;
    userId: number;
};
export type PostTicketsByTicketIdShareApiResponse = {
    detail?: string;
};
export type PostTicketsByTicketIdShareApiArg = {
    ticketId: string;
    body: {
        emailsTo?: string[];
        emailsCc?: string[];
        emailsBcc?: string[];
        body?: string;
        subject?: string;
        /** Multiple files allowed. */
        uploadedAttachments?: Blob;
        /** JSON-encoded list of {type: existingAttachment|existingVersion, id, name}. */
        onPlatformAttachments: string;
        /** JSON-encoded object; if non-empty must contain a partyId UUID. */
        turnTracking?: string;
    };
};
export type PostTicketsByTicketIdSignEnvelopeApiResponse = 
/** status 200 OK */ RedirectUrl;
export type PostTicketsByTicketIdSignEnvelopeApiArg = {
    ticketId: string;
    body: {
        ticketUrl: string;
    };
};
export type DeleteTicketsByTicketIdSignersApiResponse = {
    deleted?: boolean;
};
export type DeleteTicketsByTicketIdSignersApiArg = {
    ticketId: string;
    body: {};
};
export type GetTicketsByTicketIdSignersApiResponse = {
    internal?: {}[];
    external?: {}[];
};
export type GetTicketsByTicketIdSignersApiArg = {
    ticketId: string;
};
export type PatchTicketsByTicketIdSignersApiResponse = {
    updated?: boolean;
};
export type PatchTicketsByTicketIdSignersApiArg = {
    ticketId: string;
    body: {
        data?: {}[];
    };
};
export type PostTicketsByTicketIdSupplierNegotiationApiResponse = 
/** status 200 OK */ {
    data?: {
        status?: string;
        action?: string;
    };
};
export type PostTicketsByTicketIdSupplierNegotiationApiArg = {
    ticketId: string;
    body: {
        /** One of the supported negotiation actions. */
        action: string;
        /** Required for the 'share' action. */
        version_id?: string;
    };
};
export type GetTicketsByTicketIdTurnTrackingsApiResponse = 
/** status 200 OK */ {}[];
export type GetTicketsByTicketIdTurnTrackingsApiArg = {
    ticketId: string;
};
export type PostTicketsByTicketIdTurnTrackingsApiResponse = 
/** status 201 Created */ {};
export type PostTicketsByTicketIdTurnTrackingsApiArg = {
    ticketId: string;
    body: {
        party_id: string;
    };
};
export type PatchTicketsByTicketIdUpdateEnvelopeApiResponse = 
/** status 200 OK */ {
    /** 'no update' or a success message. */
    data?: string;
};
export type PatchTicketsByTicketIdUpdateEnvelopeApiArg = {
    ticketId: string;
};
export type GetTicketsByTicketIdWellKnownFieldsApiResponse = 
/** status 200 OK */ {
    /** Keyed by well-known field key. */
    fields?: object;
};
export type GetTicketsByTicketIdWellKnownFieldsApiArg = {
    ticketId: string;
};
export type PatchTicketsByTicketIdIssuesAndIssueIdApproveApiResponse = 
/** status 200 OK */ {};
export type PatchTicketsByTicketIdIssuesAndIssueIdApproveApiArg = {
    ticketId: string;
    issueId: string;
    body: {
        /** One of the EntityType enum values. */
        entityType: string;
        comment?: string;
        status?: string;
    };
};
export type PatchTicketsByTicketIdIssuesAndIssueIdRejectApiResponse = 
/** status 200 OK */ {};
export type PatchTicketsByTicketIdIssuesAndIssueIdRejectApiArg = {
    ticketId: string;
    issueId: string;
    body: {
        /** One of the EntityType enum values. */
        entityType: string;
        comment?: string;
        status?: string;
    };
};
export type PatchTicketsByTicketIdIssuesAndIssueIdResetApiResponse = 
/** status 200 OK */ {};
export type PatchTicketsByTicketIdIssuesAndIssueIdResetApiArg = {
    ticketId: string;
    issueId: string;
    body: {
        /** One of the EntityType enum values. */
        entityType: string;
        assignees?: string[];
    };
};
export type PatchTicketsByTicketIdIssuesAndIssueIdReassignApiResponse = 
/** status 200 OK */ {};
export type PatchTicketsByTicketIdIssuesAndIssueIdReassignApiArg = {
    ticketId: string;
    issueId: string;
    body: {
        /** One of the EntityType enum values. */
        entityType: string;
        oldUserId?: string;
        assigneeUserId: string;
    };
};
export type GetTicketsByTicketIdIssuesAndIssueIdApprovalsApiResponse = 
/** status 200 OK */ {
    data?: {}[];
};
export type GetTicketsByTicketIdIssuesAndIssueIdApprovalsApiArg = {
    ticketId: string;
    issueId: string;
    /** One of the EntityType enum values, e.g. 'risk' or 'ticket_judgment'. */
    entityType: string;
};
export type PostTicketsByTicketIdJudgmentResultsAndJudgmentResultIdRemindApiResponse = 
/** status 200 OK */ {};
export type PostTicketsByTicketIdJudgmentResultsAndJudgmentResultIdRemindApiArg = {
    ticketId: string;
    judgmentResultId: string;
};
export type GetTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenApproveApiResponse = unknown;
export type GetTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenApproveApiArg = {
    ticketId: string;
    judgmentResultId: string;
    /** Email action token. */
    token: string;
};
export type PatchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenApproveApiResponse = 
/** status 200 OK */ {
    judgment_result_id?: string;
    status?: string;
};
export type PatchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenApproveApiArg = {
    ticketId: string;
    judgmentResultId: string;
    /** Email action token. */
    token: string;
    body: {
        /** JSON-encoded object, e.g. {comment: string}. */
        payload: string;
    };
};
export type GetTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenRejectApiResponse = unknown;
export type GetTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenRejectApiArg = {
    ticketId: string;
    judgmentResultId: string;
    /** Email action token. */
    token: string;
};
export type PatchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenRejectApiResponse = 
/** status 200 OK */ {
    judgment_result_id?: string;
    status?: string;
};
export type PatchTicketsByTicketIdJudgmentResultsAndJudgmentResultIdTokenRejectApiArg = {
    ticketId: string;
    judgmentResultId: string;
    /** Email action token. */
    token: string;
    body: {
        /** JSON-encoded object, e.g. {comment: string}. */
        payload: string;
    };
};
export type PatchTicketsByTicketIdStagesAndStageIdApiResponse = 
/** status 200 OK */ {};
export type PatchTicketsByTicketIdStagesAndStageIdApiArg = {
    ticketId: string;
    stageId: string;
    body: {
        userId: string;
    };
};
export type PatchTicketsByTicketIdStagesAndStageIdResetApprovalsApiResponse = 
/** status 200 OK */ {};
export type PatchTicketsByTicketIdStagesAndStageIdResetApprovalsApiArg = {
    ticketId: string;
    stageId: string;
    body: {
        comment?: string;
    };
};
export type OauthTokenResponse = {
    /** access token */
    access_token: string;
    /** Base path to use for API calls to the corresponding integration */
    base_path: string;
    /** ISO timestamp indicating when the token will expire */
    token_expiration?: string;
};
export type Version = {
    documentId?: string;
    tag?: number;
    text?: string;
};
export type VersionBackup = {
    id?: string;
    file_location?: string;
    file_type?: string;
    user_ext_id?: number;
    user_name?: string;
    version_id?: string;
};
export type Workflow = {
    fields?: object;
    settings?: object;
    signers?: object;
    id?: string;
    createdBy?: number;
    createdDate?: string;
    hasCompanyPaper?: boolean;
    hasCounterpartyPaper?: boolean;
    modifiedDate?: string;
    name?: string;
    review?: {
        coordinatorId?: number;
        phases?: object[];
        finalizeCriterias?: object[];
    };
    published?: boolean;
    completed?: boolean;
    sourceFiles?: object[];
    errors?: object[];
};
export type LinksResponse = {
    /** Resource type. */
    type: string;
    /** Ticket identifier. */
    id: string;
    /** Map of link rels to URLs. */
    links: {
        [key: string]: string;
    };
};
export type CreateTicketPackageRequest = {
    /** Target e-sign vendor. */
    vendor: "DOCUSIGN" | "ADOBESIGN";
    /** URL to redirect the sender after completing the action. */
    returnUrl: string;
};
export type ConsolidatedRecipient = {
    /** Recipient display name. */
    name?: string;
    /** Recipient email. */
    email?: string;
};
export type Status = {
    /** Human-readable status. */
    label: string;
    /** Machine-readable status code. */
    value: string;
};
export type ConsolidatedSigner = ConsolidatedRecipient & {
    /** Internal pilot user ID if applicable. */
    pilot_user_id?: number;
    /** Whether the signer is external to the organization. */
    is_external: boolean;
    status: Status;
    /** Signer recipient identifier. */
    recipient_id: string;
    /** Timestamp of the signature if completed. */
    signed_date_time?: string;
    /** Signing order. */
    order: number;
};
export type PackageRecipients = {
    signers: ConsolidatedSigner[];
    carbon_copies: ConsolidatedRecipient[];
};
export type GetPackageRecipientsResponseAttributes = {
    recipients: PackageRecipients;
};
export type GetPackageRecipientsResponseData = {
    type: string;
    id: string;
    attributes: GetPackageRecipientsResponseAttributes;
};
export type GetPackageRecipientsResponse = {
    data: GetPackageRecipientsResponseData;
};
export type PackageActivity = {
    /** ISO 8601 timestamp for the activity. */
    timestamp: string;
    /** Activity message. */
    message: string;
    /** Name of the user associated with the activity. */
    username: string;
};
export type GetPackageActivitiesResponseAttributes = {
    activities: PackageActivity[];
};
export type GetPackageActivitiesResponseData = {
    type: string;
    id: string;
    attributes: GetPackageActivitiesResponseAttributes;
};
export type GetPackageActivitiesResponse = {
    data: GetPackageActivitiesResponseData;
};
export type SignTicketPackageRequest = {
    /** Target e-sign vendor. */
    vendor: "DOCUSIGN" | "ADOBESIGN";
    /** URL to redirect the signer. */
    returnUrl: string;
    /** Identifier of the recipient. */
    recipientId: string;
};
export type ViewTicketPackageRequest = {
    /** Target e-sign vendor. */
    vendor: "DOCUSIGN" | "ADOBESIGN";
    /** URL to redirect after viewing the package. */
    returnUrl: string;
};
export type RemindSignerResponseAttributes = {
    /** Recipient that was reminded. */
    recipient_id: string;
};
export type RemindSignerResponseData = {
    type: string;
    id: string;
    attributes: RemindSignerResponseAttributes;
};
export type RemindSignerResponse = {
    data: RemindSignerResponseData;
};
export type RemindSignerRequest = {
    /** Target e-sign vendor. */
    vendor: "DOCUSIGN" | "ADOBESIGN";
    /** Identifier of the recipient to remind. */
    recipientId: string;
};
export type InitialSignerData = {
    /** Signer name. */
    name?: string;
    /** Signer email. */
    email?: string;
    /** Whether the signer is external to the organization. */
    is_external: boolean;
    /** Map of anchor tags populated for the signer. */
    anchor_tag_values: object;
    /** JudgmentStatus code. */
    status: string;
    /** Signing order. */
    order: number;
    /** Signer recipient identifier. */
    recipient_id: string;
    /** Pilot user ID if assigned. */
    pilot_user_id?: number;
};
export type GetInitialSignersResponseAttributes = {
    initial_signers: InitialSignerData[];
};
export type GetInitialSignersResponseData = {
    type: string;
    id: string;
    attributes: GetInitialSignersResponseAttributes;
};
export type GetInitialSignersResponse = {
    data: GetInitialSignersResponseData;
};
export type ReassignInitialSignerRequest = {
    /** Identifier of the signer to replace. */
    recipientId: string;
    /** Pilot user ID of the new signer. */
    newSignerUserId: number;
};
export type ESignatureRequest = {
    config?: {
        enableTestingMode?: boolean;
    };
    isDefault?: boolean;
    shouldUseCompanyAccount?: boolean;
    type?: "adobesign" | "docusign";
};
export type ESignatureResponse = ESignatureRequest & {};
export type ESignatureResponseRead = ESignatureRequest & {
    clientId?: string;
    error?: object | null;
    id: string;
    isUserLoggedIn?: boolean;
};
export type HasESignaturesResponse = {
    hasEsignatureIntegrations: boolean;
};
export type IntakeFormField = {
    type: string;
    options?: object;
};
export type IntakeFormQuestion = {
    title: string;
    description?: string;
    position: number;
    isRequired: boolean;
    field: IntakeFormField;
};
export type IntakeFormSection = {
    name: string;
    description?: string;
    position: number;
    questions?: IntakeFormQuestion[];
};
export type IntakeFormRes = {
    id?: string;
    name?: string;
    description?: string;
    workflowId?: string;
    type?: string;
    sections?: IntakeFormSection[];
};
export type IntakeFormReq = {
    name: string;
    description?: string;
    workflowId: string;
    type: string;
    sections: IntakeFormSection[];
};
export type ActivityLog = {
    /** JudgmentResult actions:
        * approved
        * rejected
      Comment/Ticket actions:
        * created
       */
    action?: "create ticket" | "create comment" | "collect signatures" | "delete comment" | "document upload" | "intake form edit" | "judgment result status update" | "judgment result reassignment" | "next stage" | "previous stage" | "rename ticket" | "signature upload" | "status update" | "ticket completion" | "update comment";
    actorId?: string;
    createdDate?: string;
    /** For a comment this will be something like:
     * {content: <comment text>
     */
    data?: object;
    targetType?: "comment" | "document" | "judgment result" | "risk" | "ticket" | "ticket judgment" | "ticket stage" | "version";
};
export type JudgmentResult = {
    id: string;
    modifiedDate?: string;
    lastReminderDate?: string | null;
    position?: number | null;
    status: string;
    userId?: number | null;
    externalUser?: (any | null) | {
        name?: string;
        id?: string;
        email?: string;
        title?: string | null;
    };
    ticketId?: string;
    judgmentId?: string;
    comment?: string | null;
    ccRecipient?: object;
};
export type CommentReq = {
    content: string;
};
export type CommentRes = CommentReq & {
    id?: string;
    ticketId: string;
};
export type TicketJudgment = {
    activities?: ActivityLog[];
    approvals: JudgmentResult[];
    comments?: CommentRes[];
    description?: string | null;
    label?: string | null;
    name?: string;
    position?: number | null;
    status?: "approved" | "rejected" | "pending" | "done" | "signed" | "signature request not sent" | "signature pending" | "queued" | "email delivery failed" | "not applicable";
};
export type TicketPhase = {
    description?: string;
    id?: string;
    label?: string;
    name: string;
    position?: number;
    status: string;
    judgments: TicketJudgment[];
};
export type TicketStage = {
    coordinatorId?: number | null;
    id?: string;
    isCompleted?: boolean;
    name?: "edit" | "review" | "sign" | "finalize";
    phases: TicketPhase[];
    status?: string;
};
export type TicketRes = {
    isCompleted?: boolean;
    assignedTo?: any[];
    fields?: any[];
    currentStage?: object;
    creatorId?: string;
    esignatureProvider?: "docusign" | "adobesign";
    id: string;
    name: string;
    isCancelled?: boolean;
    workflowId?: string;
    stages?: {
        edit?: TicketStage;
        review?: TicketStage;
        sign?: TicketStage;
        finalize?: TicketStage;
    };
    stage?: ("edit" | "review" | "sign" | "finalize" | "ticket") | null;
    status: "editing" | "in review" | "pending signatures" | "pending finalization" | "pending completion" | "completed" | "cancelled";
};
export type IntakeFormFieldValue = {
    fieldId: string;
    value: object;
};
export type TicketReq = {
    name: string;
    workflowId: string;
    fields?: IntakeFormFieldValue[];
};
export type TurnTrackingReq = {
    partyId: string;
};
export type DocumentMetaData = {
    id?: string;
    lastModifiedById?: number | null;
    lastModifiedByEmail?: string | null;
    modifiedDate?: string;
    name?: string;
    type?: string;
    version?: number;
};
export type GetTicketRes = {
    createdDate?: string;
    creatorId?: number;
    document?: DocumentMetaData;
    esignatureProvider?: ("docusign" | "adobesign" | null) | null;
    id: string;
    name: string;
    permissions?: string[];
    permissionMap?: {
        edit?: any[];
        review?: any[];
        sign?: any[];
        finalize?: any[];
    };
    stage?: ("edit" | "review" | "sign" | "finalize" | "ticket") | null;
    stages?: {
        edit?: TicketStage;
        review?: TicketStage;
        sign?: TicketStage;
        finalize?: TicketStage;
    };
    status: "editing" | "in review" | "pending signatures" | "pending finalization" | "pending completion" | "completed" | "cancelled";
};
export type TurnTrackingEditReq = {
    party_id?: any[];
    start_time?: string;
    end_time?: string;
};
export type JudgmentResultReq = {
    status: "approved" | "rejected" | "pending" | "done" | "signed" | "signature request not sent" | "signature pending" | "queued" | "email delivery failed" | "not applicable";
    comment?: string;
};
export type Error = {
    data: string;
};
export type DocumentDetails = {
    id?: string;
    currentVersionId?: string;
    fileSize?: number;
    hasSignatures?: boolean;
    lastModifiedByEmail?: string;
    lastModifiedById?: number;
    modifiedDate?: string;
    name?: string;
    version?: number;
};
export type User = {
    email?: string;
    extId?: number;
    id?: string;
    name?: string;
};
export type TicketSummary = {
    id?: string;
    cancelledDate?: string;
    createdDate?: string;
    creator?: User;
    esignatureProvider?: "docusign" | "adobesign";
    hasUnpopulatedSignerField?: boolean;
    inboundEmailAddress?: string;
    isCancelled?: boolean;
    isCompleted?: boolean;
    name?: string;
    workflowId?: string;
    parties?: string[];
    permissionMap?: {
        edit?: any[];
        review?: any[];
        sign?: any[];
        finalize?: any[];
        ticket?: any[];
    };
    permissions?: string[];
    pilotDocHandlerId?: number;
    stage?: "edit" | "review" | "sign" | "finalize" | "ticket";
    status?: "editing" | "in review" | "pending signatures" | "pending finalization" | "pending completion" | "completed" | "cancelled";
    wasManuallyUpdated?: boolean;
};
export type PermissionsMap = {
    /** The id of the entity */
    entity_id?: string;
    /** The type of entity */
    entity_type?: string;
    /** The accesibility to the entity for each user */
    user_permission_map?: {
        /** The id if the user in UUID format */
        user_id?: {
            /** True if the user has access */
            has_access?: boolean;
            /** The type of access the user has for the entity */
            permission_type?: string;
        };
    };
};
export type PermissionsBody = {
    /** The ids from the users to get the accessibility permissions */
    user_ids: string[];
    /** The id of the entity to check the accessibility permissions */
    entity_id: string;
    /** The type of entity to get the accessibility permissions (only Ticket is implemented) */
    entity_type: string;
};
export type RoutingStatus = "active" | "inactive";
export type Routing = {
    /** Routing entry UUID */
    id?: string;
    /** Destination workflow ID */
    workflowId?: string;
    /** Name of the route */
    routeName?: string;
    status?: RoutingStatus;
    /** Workflow routing instructions */
    instructions?: string;
    /** Record creation timestamp */
    createdDate?: string;
    /** Last modification timestamp */
    modifiedDate?: string;
    /** User ID who created this record */
    createdById?: string;
    /** User ID who last modified this record */
    modifiedById?: string;
    /** Version number for optimistic locking */
    versionNumber?: number;
    /** Display name of the user who created this record. Only populated in search results. */
    createdByName?: string;
    /** Display name of the user who last modified this record. Only populated in search results. */
    modifiedByName?: string;
    /** Published workflow ID to use for ticket creation. This is the actual published workflow ID (either the ancestor if published, or its published child). Only populated in search results. */
    publishedWorkflowId?: string | null;
};
export type RoutingResponse = {
    data?: Routing;
};
export type ErrorResponse = {
    /** Machine-readable error code */
    error_code?: string;
    /** Human-readable error message */
    message?: string;
    /** Additional error details */
    details?: {
        [key: string]: any;
    };
};
export type RoutingCreateRequest = {
    /** Destination workflow ID */
    workflowId: string;
    /** Name of the route */
    routeName: string;
    status: RoutingStatus;
    /** Workflow routing instructions */
    instructions: string;
};
export type RoutingSearchResponse = {
    /** List of routing entries matching search criteria */
    data?: Routing[];
    /** Total number of records matching the search */
    totalRecords?: number;
    /** Total number of pages */
    totalPages?: number;
    /** Current page number */
    currentPage?: number;
    /** Number of items per page */
    pageSize?: number;
};
export type RoutingUpdateRequest = {
    /** Destination workflow ID */
    workflowId: string;
    /** Name of the route */
    routeName: string;
    status: RoutingStatus;
    /** Workflow routing instructions */
    instructions: string;
    /** Version number for optimistic locking */
    versionNumber: number;
};
export type UnroutedWorkflow = {
    /** Workflow UUID */
    workflowId?: string;
    /** Workflow name */
    name?: string;
    /** Workflow description */
    description?: string;
};
export type ActivationStatus = "active" | "inactive";
export type RoutingConfiguration = {
    /** Configuration entry UUID */
    id?: string;
    allUserActivationStatus?: ActivationStatus;
    /** General routing instructions */
    instructions?: string;
    /** Fallback response text */
    fallbackResponse?: string;
    /** First activation timestamp */
    firstActivationDate?: string;
    /** Last activation timestamp */
    lastActivationDate?: string;
    /** Record creation timestamp */
    createdDate?: string;
    /** Last modification timestamp */
    modifiedDate?: string;
    /** User ID who created this record */
    createdById?: string;
    /** User ID who last modified this record */
    modifiedById?: string;
    /** Version number for optimistic locking */
    versionNumber?: number;
};
export type RoutingConfigurationResponse = {
    data?: RoutingConfiguration;
};
export type RoutingConfigurationPatchRequest = {
    /** Activation status. If not provided and creating new record, defaults to 'inactive' */
    allUserActivationStatus?: ActivationStatus;
    /** General routing instructions */
    instructions?: string;
    /** Fallback response text */
    fallbackResponse?: string;
    /** Version number for optimistic locking.
      - Required when updating an existing record
      - Ignored when creating a new record
       */
    versionNumber?: number;
};
export type ActivationStatusResponse = {
    data?: {
        allUserActivationStatus?: ActivationStatus;
        /** First activation timestamp */
        firstActivationDate?: string;
        /** Last activation timestamp */
        lastActivationDate?: string;
        /** Version number for optimistic locking */
        versionNumber?: number;
    };
};
export type TurnTrackingParty = {
    id?: string;
    name?: string;
    type?: "company" | "counterparty";
};
export type TurnTrackingPartiesRes = TurnTrackingParty[];
export type CrmResponse = {
    config?: object;
    provider?: "SALESFORCE";
};
export type CrmResponseRead = {
    clientId?: string;
    config?: object;
    error?: object | null;
    id: string;
    isUserLoggedIn?: boolean;
    provider?: "SALESFORCE";
};
export type ESignatureLoggedInResponse = {
    isUserEsignatureLoggedIn: boolean;
    redirectUrl?: string;
};
export type RedirectUrl = {
    redirectUrl: string;
};
